import { useState } from 'react';
import { KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { parseSlotDroppableId } from '../lib/cadenceSlotId';
import { moveTemplateToStep } from '../lib/cadenceStepMoves';

export function useCampaignCadenceStepsDnd(steps, onStepsChange) {
  const [activeSlot, setActiveSlot] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(KeyboardSensor),
  );

  const onDragStart = ({ active }) => setActiveSlot(active?.data?.current ?? null);
  const onDragCancel = () => setActiveSlot(null);

  const onDragEnd = ({ active, over }) => {
    setActiveSlot(null);
    if (!over) return;

    const from = active?.data?.current;
    const to = parseSlotDroppableId(over.id);
    if (!from || !to || to.language !== from.language) return;

    onStepsChange(
      moveTemplateToStep(steps, {
        fromIndex: from.stepIndex,
        toIndex: to.stepIndex,
        language: from.language,
      }),
    );
  };

  return { sensors, activeSlot, onDragStart, onDragEnd, onDragCancel };
}
